import React, { useEffect, useState } from "react";
import "../style.scss";
import { httpService } from "../../../base/services/httpService.service";
import ProgressUsage from "./ProgressUsage";
import { useTranslation } from "../../../i18n/LanguageContext";

const UsageStatistics = () => {
   const { t } = useTranslation();
   const [usedStorageData, setUsedStorageData] = useState(0);
   const [totalStorageData, setTotalStorageData] = useState(1);

   const convertBytesToGB = (bytes) => {
      return (bytes / 1024 ** 3).toFixed(2);
   };
   // if a number is a whole number, ex: 5.00 round it up to 5
   const formatGB = (value) => {
      const number = parseFloat(value);
      return number % 1 === 0 ? number.toFixed(0) : number.toFixed(2);
   };

   const usagePercentage = totalStorageData
      ? ((usedStorageData / totalStorageData) * 100).toFixed(2)
      : 0;
   const availableStoragePercentage = totalStorageData
      ? (((totalStorageData - usedStorageData) / totalStorageData) * 100).toFixed(2)
      : 0;

   const usedStorageGB = formatGB(convertBytesToGB(usedStorageData));
   const totalStorageGB = formatGB(convertBytesToGB(totalStorageData));

   const getStatisticsDataUsage = async () => {
      try {
         await httpService.get("/DataUsage", (res) => {
            const usedStorage = res?.data?.usedStorage;
            const totalStorage = res?.data?.totalStorage;
            setUsedStorageData(usedStorage);
            setTotalStorageData(totalStorage);
         });
      } catch (error) {
         console.log(error);
      }
   };

   useEffect(() => {
      getStatisticsDataUsage();
   }, []);

   const fields = [
      {
         fieldType: t("amount-of-storage-label"),
         usagePercentage: usagePercentage,
         usedStorageGB: usedStorageGB,
         availableStoragePercentage: availableStoragePercentage
      },
      {
         fieldType: t("data-usage-label"),
         usagePercentage: usagePercentage,
         usedStorageGB: totalStorageGB,
         availableStoragePercentage: usagePercentage
      }
   ];

   return (
      <div className="usageStatisticsContainer">
         <label className="labelStatus">{t("usage-statistics-label")}</label>
         <div className="amountContainer d-flex flex-wrap">
            {fields.map((propertyType, index) => (
               <div key={index} className="storageAmount">
                  <ProgressUsage {...propertyType} />
               </div>
            ))}
         </div>
      </div>
   );
};
export default UsageStatistics;
